import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const PhotoIcon = ({ ...props }: any) => {
	return (
		<Icon
			viewBox="0 0 14 12"
			width="14"
			height="12"
			fill="none"
			{...props}
		>
			<path
				d="M12.8973 9.96889C12.8973 10.2662 12.7792 10.5514 12.5689 10.7616C12.3587 10.9719 12.0735 11.09 11.7762 11.09H1.68617C1.38884 11.09 1.10368 10.9719 0.893429 10.7616C0.68318 10.5514 0.565063 10.2662 0.565063 9.96889V3.80278C0.565063 3.50544 0.68318 3.22028 0.893429 3.01003C1.10368 2.79978 1.38884 2.68167 1.68617 2.68167H3.9284L5.04951 1H8.41284L9.53395 2.68167H11.7762C12.0735 2.68167 12.3587 2.79978 12.5689 3.01003C12.7792 3.22028 12.8973 3.50544 12.8973 3.80278V9.96889Z"
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.73111 8.84724C7.96946 8.84724 8.97334 7.84336 8.97334 6.60501C8.97334 5.36667 7.96946 4.36279 6.73111 4.36279C5.49277 4.36279 4.48889 5.36667 4.48889 6.60501C4.48889 7.84336 5.49277 8.84724 6.73111 8.84724Z"
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
